import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { CommitteeDto } from '../../shared/dto/committee.dto';
import { SelectItem } from 'primeng/api';
import { TranslationService } from 'src/app/shared';
import { PrimeNgDropdownEvent } from 'src/app/shared/primeng/events/dropdown-event';
import { ControlContainer, NgForm } from '@angular/forms';
import { CommitteeTypeService } from '../../shared/committee-type.service';
import { AffCodeService } from 'src/app/affcode/shared/affcode.service';
import { UserService } from 'src/app/users/shared/user.service';
import { TermSettingsEnum } from '../../shared/enum/term-settings.enum';
import { Optional, SkipSelf } from '@angular/core';

@Component({
  selector: 'wl-committee-details-edit',
  templateUrl: './committee-details-edit.component.html',
  styleUrls: ['./committee-details-edit.component.less'],
  viewProviders: [
  {
    provide: ControlContainer,
    useFactory: (container: ControlContainer) => container,
    deps: [[new Optional(), new SkipSelf(), ControlContainer]]
  }],
    standalone: false
})
export class CommitteeDetailsEditComponent implements OnInit, OnChanges {
  @Input() committee: CommitteeDto;
  selectedDefaultTerm: TermSettingsEnum;
  termSettingsEnum = TermSettingsEnum;
  termOptions: SelectItem[] = [];
  committeeTypeItems: SelectItem[] = [];
  affCodeItems: SelectItem[] = [];
  activeUserItems: SelectItem[] = [];

  constructor(
    private _translationService: TranslationService,
    private _committeeTypeService: CommitteeTypeService,
    private _affCodeService: AffCodeService,
    private _userService: UserService
  ) {}

  async ngOnInit(): Promise<void> {
    await this.setupTermOptions();

    this._committeeTypeService.getAllTypes().then((types) => {
      this.committeeTypeItems = types.map<SelectItem>((type) => {
        return { label: type.CommitteeType1, value: type.CommitteeType1 };
      });
    });

    this._affCodeService.getAllAffCodes().then((codes) => {
      this.affCodeItems = codes.map<SelectItem>((code) => {
        return { label: code.AffCode, value: code.AffCode };
      });
    });

    this._userService.getActiveUsers().then((users) => {
      this.activeUserItems = users.map<SelectItem>((user) => {
        return { label: user.UserName, value: user.UserName };
      });
    });
  }

  ngOnChanges() {
    if (this.committee) {
      this.setDefaultValues();
    }
  }

  termSettingsChange(event: PrimeNgDropdownEvent<TermSettingsEnum>) {
    if (event.value !== TermSettingsEnum.Custom) {
      this.committee.TermMonths = event.value;
    }
  }

  private async setupTermOptions() {
    this.termOptions = [
      {
        label: await this._translationService.getTitlecase('committees.edit.committee-details.terms.never-expires'),
        value: TermSettingsEnum.NeverExpires,
      },
      {
        label: await this._translationService.getTitlecase('committees.edit.committee-details.terms.one-year'),
        value: TermSettingsEnum.OneYear,
      },
      {
        label: await this._translationService.getTitlecase('committees.edit.committee-details.terms.two-years'),
        value: TermSettingsEnum.TwoYears,
      },
      {
        label: await this._translationService.getTitlecase('committees.edit.committee-details.terms.three-years'),
        value: TermSettingsEnum.ThreeYears,
      },
      {
        label: await this._translationService.getTitlecase('committees.edit.committee-details.terms.custom-number-of-months'),
        value: TermSettingsEnum.Custom,
      },
    ];
  }

  private setDefaultValues() {
    this.committee.TermMonths = this.committee.TermMonths ?? 0;

    switch (this.committee.TermMonths) {
      case 0:
        this.selectedDefaultTerm = TermSettingsEnum.NeverExpires;
        break;
      case 12:
        this.selectedDefaultTerm = TermSettingsEnum.OneYear;
        break;
      case 24:
        this.selectedDefaultTerm = TermSettingsEnum.TwoYears;
        break;
      case 36:
        this.selectedDefaultTerm = TermSettingsEnum.ThreeYears;
        break;
      default:
        this.selectedDefaultTerm = TermSettingsEnum.Custom;
    }
  }
}
